<template>
    <div v-if="listready" class="wrapper">
        <div class="animated fadeIn">
            <b-card header="<i class='fa fa-align-justify'></i><strong> Teelten</strong>">
                <filter-form
                        :bedrijven="bedrijven"
                        :afdelingen="afdelingen"
                        :currentFilter="currentFilter"
                        @get-items="getItems">
                </filter-form>
                <br />
                <item-list
                        :items="items"
                        @delete-item="deleteItem"
                        @destroy-item="destroyItem">
                </item-list>
            </b-card>
        </div>

        <b-modal title="Verwijderen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Deze teelt kan niet verwijderd worden! Aan deze teelt zijn nog andere gegevens gekoppeld. {{errormsg}}
        </b-modal>

        <b-modal title="Teelt verwijderen" size="sm" class="modal-primary" v-model="warningGeduld">
            <div slot="modal-footer" class="w-100"><p>Even geduld a.u.b.</p></div>
            <p><fadeloader :loading="loading" :size="size" :color="color" class="spinner"></fadeloader></p>
            <p>&nbsp;<br/>&nbsp;</p>
            <p>Teelt (incl. belichting) wordt verwijderd. Deze bewerking kan even duren.</p>
        </b-modal>

    </div>
</template>

<script>
    import api from '../../api/afdelingteelt';
    import FilterForm from './FilterForm';
    import ItemList from './List';
    import FadeLoader from 'vue-spinner/src/FadeLoader';

    export default {
        data () {
            return {
                warningModal: false,
                listready: false,
                errormsg: '',
                bedrijven: [],
                afdelingen: [],
                items: [],

                warningGeduld: false,
                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        computed: {
            currentFilter () {
                const filter = this.$store.getters.afdelingteeltFilter;
                return Object.assign({}, filter);
            },
        },
        created () {
            this.getItems(true);
        },
        methods: {
            getItems (withselect) {
                this.$store.dispatch('saveAfdelingteeltFilter', this.currentFilter);
                api.getListAfdelingteelt(withselect, this.currentFilter.bedrijf,
                    this.currentFilter.afdeling,
                    this.currentFilter.historiek).then((response) => {
                    if (withselect) {
                        this.bedrijven = response.data.bedrijven;
                        this.bedrijven.unshift({ id: 0, naam: '-- Alle --' });
                        this.afdelingen = response.data.afdelingen;
                        this.afdelingen.unshift({ id: 0, naam: '-- Alle --', bedrijf: { naam: '' } });
                    }
                    this.items = response.data.items;
                    this.listready = true;
                });
            },
            deleteItem (id) {
                api.deleteAfdelingteelt(id).then(() => {
                    this.getItems(false);
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            destroyItem (id) {
                this.warningGeduld = true;
                api.destroyAfdelingteelt(id).then(() => {
                        this.warningGeduld = false;
                        this.getItems(false);
                    },
                    (error) => {
                        this.warningGeduld = false;
                        this.errormsg = error.message;
                        this.warningModal = true;
                    });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'filter-form': FilterForm,
            'item-list': ItemList,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

</style>



// WEBPACK FOOTER //
// src/pages/afdelingteelt/Index.vue